/**
 * Pure noun helpers behind `QuickStudyNounProvider` (see quickStudyNoun.tsx):
 * what the shared quick-study chart copy calls the people who answered.
 * "twins" is the default and keeps the Studies report unchanged.
 */
export type RespondentNoun = 'twins' | 'respondents'

/** "twin" / "twins" / "respondent" / "respondents" for a count. */
export function respondentNoun(count: number, noun: RespondentNoun = 'twins'): string {
  const singular = noun === 'respondents' ? 'respondent' : 'twin'
  return count === 1 ? singular : `${singular}s`
}

/**
 * A segment label as it may read in user-facing copy: em and en dashes become
 * "to" between numbers ("21–34" reads "21 to 34") and a comma elsewhere.
 * Blank in, empty string out.
 */
export function cleanSegmentLabel(label: string | null | undefined): string {
  if (typeof label !== 'string') {
    return ''
  }
  return label
    .replace(/(\d)\s*[–—]\s*(\d)/g, '$1 to $2')
    .replace(/\s*[–—]\s*/g, ', ')
    .replace(/\s+/g, ' ')
    .trim()
}

/** `base` followed by the segment, when there is one: "40 respondents, women 21 to 34". */
export function withSegment(base: string, segmentLabel: string | null | undefined): string {
  const segment = cleanSegmentLabel(segmentLabel)
  return segment ? `${base}, ${segment}` : base
}
